import styled from 'styled-components';

import {
   PatientDataAccessApplicationResult,
   PatientDataAccessApplicationVisitCommand,
   PatientDataAccessP1UnavailableFault,
   PatientDataAccessUnconfiguredIKPAccountFault,
   PatientDataAccessVerificationFault,
} from '@dreryk/egabinet-patient-access-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { Button, ButtonVariant } from '@dreryk/react-components';

import {
   PatientDataAccessFormBean,
   PatientDataAccessFormController,
} from '../PatientDataAccessForm/PersonDataAccessForm.types';
import { prescriptionsHistoryDownloadTranslationKeys } from '../translations';

export type OnPatientDataAccessApplicationVisitSuccess = (applicationId: string) => void;
export type onPatientDataAccessVerificationFault = (description: string | undefined) => void;

type PatientDataAccessApplicationVisitFault =
   | PatientDataAccessP1UnavailableFault
   | PatientDataAccessVerificationFault
   | PatientDataAccessUnconfiguredIKPAccountFault;

type PatientDataAccessAuthorizerSendButtonProps = {
   readonly visitId: number;
   readonly handleSubmit: PatientDataAccessFormController['handleSubmit'];
   readonly onSuccess: OnPatientDataAccessApplicationVisitSuccess;
   readonly onP1CommunicationFault: VoidFunction;
   readonly onPatientIkpNotConfiguredFault: VoidFunction;
   readonly onPatientDataAccessVerificationFault: onPatientDataAccessVerificationFault;
};

const StyledButton = styled(Button)`
   align-self: flex-end;
`;

export const PatientDataAccessSendDataAccessRequestButton = (
   props: PatientDataAccessAuthorizerSendButtonProps
): JSX.Element => {
   const { executeAsync: sendDataAccessRequest } = useCqrsCommand<
      PatientDataAccessApplicationResult,
      PatientDataAccessFormBean,
      PatientDataAccessApplicationVisitFault
   >(
      (parameters) => {
         const command = new PatientDataAccessApplicationVisitCommand();
         command.visitId = props.visitId;
         command.authorizer = parameters.authorizer!;
         return command;
      },
      {
         onSuccess: ({ applicationId }) => props.onSuccess(applicationId),
         onFault: {
            'egabinet-patient-access-frontend-api:PatientDataAccessP1UnavailableFault': () =>
               props.onP1CommunicationFault(),
            'egabinet-patient-access-frontend-api:PatientDataAccessVerificationFault': (fault) =>
               props.onPatientDataAccessVerificationFault(fault.description),
            'egabinet-patient-access-frontend-api:PatientDataAccessUnconfiguredIKPAccountFault':
               props.onPatientIkpNotConfiguredFault,
         },
      }
   );
   return (
      <StyledButton
         label={prescriptionsHistoryDownloadTranslationKeys.sendDataAccessRequest}
         testId={'sendDataAccessRequest'}
         variant={ButtonVariant.SECONDARY}
         onClick={props.handleSubmit(sendDataAccessRequest)}
      />
   );
};
